const {addMiddleware} = require("./WfUtil");

const closeModal = function(wrapperEl) {
	const closer = wrapperEl.getElementsByClassName("close-block")[0];
	if (closer) {
		closer.click();
	}
};

const closeModalFromChild = function(childEl) {
	const wrapper = getModalWrapperFromChild(childEl);
	closeModal(wrapper);
};

const getModalWrapperFromAction = function(action) {
	const el = action.payload.element;
	return el && el.classList.contains("modal-wrapper") ? el : null;
};

const getModalWrapperFromChild = function(childEl) {
	return childEl.closest(".modal-wrapper");
};

const getModalWrapperFromId = function(id) {
	return document.getElementById(id);
};

function onModalClose(fn, modalId = null) {
	return onModalToggle(fn, "close", modalId);
}

function onModalOpen(fn, modalId = null) {
	return onModalToggle(fn, "open", modalId);
}

function onModalToggle(fn, type, modalId = null) {
	if (typeof fn !== "function") {
		return;
	}

	const isModalOpening = function(action) {
		return action.payload.destination.value !== "none";
	};

	function doModalMiddleware(action) {
		const el = getModalWrapperFromAction(action);
		if (!el) {
			return action;
		}
		if (modalId && modalId !== el.id) {
			return action;
		}
		const isOpening = el && isModalOpening(action);
		if (isOpening && type === "open") {
			fn(el, action);
		} else if (!isOpening && type === "close") {
			fn(el, action);
		}
		return action;
	}
	addMiddleware(doModalMiddleware);
	return doModalMiddleware;
}

module.exports = {
	closeModal,
	closeModalFromChild,
	getModalWrapperFromAction,
	getModalWrapperFromChild,
	getModalWrapperFromId,
	onModalClose,
	onModalOpen,
	onModalToggle,
};
